import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './ListWithDescription.module.css';
import { IconArrow } from '../../../components';

const ListWithDescription = ({ className, rootClassName, config, onLinkClick }) => {
  const classes = classNames(rootClassName || css.root, className);
  const menu = config.config.navConfig;
  const asideConfig = config.config.aside;
  const fallbackLink = config.config.fallbackLink;

  return (
    <div className={classes}>
      <div className={css.menuSection}>
        {menu.map(m => (
          // Rendered as an anchor: these were inert <div>s that looked
          // interactive but could not be clicked or reached by keyboard.
          <a
            key={m.id}
            className={css.menu}
            href={m.link || fallbackLink || '#'}
            onClick={onLinkClick}
          >
            <span className={css.menuHeading}>{m.label}</span>
            <span className={css.menuDescription}>{m.description}</span>
          </a>
        ))}

        {asideConfig && (
          <aside className={css.aside}>
            <h3 className={css.title}>{asideConfig.title}</h3>
            <p className={css.description}>{asideConfig.description}</p>
            <div className={css.image}>
              <img src={asideConfig.image} alt={asideConfig.imageAlt} loading="lazy" />
            </div>
            <div className={css.asideLink}>
              <a href={asideConfig.link.link} onClick={onLinkClick}>
                <span>{asideConfig.link.label}</span>
                <IconArrow direction="right" size="small" aria-hidden="true" />
              </a>
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

ListWithDescription.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  onLinkClick: PropTypes.func,
  config: PropTypes.shape({
    config: PropTypes.shape({
      navConfig: PropTypes.array.isRequired,
      aside: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.string,
        imageAlt: PropTypes.string,
        link: PropTypes.shape({ link: PropTypes.string, label: PropTypes.string }),
      }),
    }),
  }).isRequired,
};

export default ListWithDescription;